import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { AnimatePresence, motion } from "framer-motion";
import { useRef, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { servicesCategory } from "../../utilities/serviceData";

//to Create the DropDown Menu
export const FlayoutLink = ({ children, href, FlayoutContent }) => {
  const [mouseOnButton, setMouseOnButton] = useState(false);
  const timeoutRef = useRef(null);
  const showFlayout = mouseOnButton && FlayoutContent;

  const onMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setMouseOnButton(true);
  };
  const onMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setMouseOnButton(false);
    }, 300);
  };

  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className="group relative h-fit w-fit"
    >
      <NavLink
        to={href}
        className={({ isActive }) =>
          `relative text-base font-normal text-visBlue ${isActive && "text-visOrange"}`
        }
      >
        <div className="flex items-center gap-0">
          <p
            className={`transition-all duration-300 ${mouseOnButton && "text-visOrange"}`}
          >
            {children}
          </p>

          {FlayoutContent && (
            <ChevronRightIcon
              className={`relative left-[1px] top-[1px] h-4 w-4 stroke-current transition-all duration-300 ${mouseOnButton && "rotate-90 text-visOrange"}`}
            />
          )}
        </div>

        <span
          className={`absolute -bottom-3 left-0 h-[1.5px] w-full origin-left scale-x-0 rounded-full font-bold transition-all duration-300 ${showFlayout && "scale-x-100"} bg-visOrange`}
        ></span>
      </NavLink>
      <AnimatePresence>
        {showFlayout && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            style={{ x: "-50%" }}
            className="W-full absolute left-1/2 top-[3.734rem] z-10"
          >
            <div className="absolute -top-[2.7rem] h-[2.41rem] w-full bg-transparent"></div>
            <FlayoutContent />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export const ServicesMenu = () => {
  return (
    <div className="relative min-w-64 divide-y-[1px] bg-white text-visBlue">
      {servicesCategory.map((item, index) => {
        return (
          <MenuItem
            key={index + item.name}
            label={item.name}
            child={item.child}
          />
        );
      })}
    </div>
  );
};

export const MenuItem = ({ label, child }) => {
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const params = useParams();
  const { id } = params;
  return (
    <>
      <div
        onMouseEnter={() => setSubMenuOpen(true)}
        onMouseLeave={() => setSubMenuOpen(false)}
        className={`relative flex cursor-pointer items-center justify-between p-3 transition-all duration-200 ${child.some((val) => val.href === id) ? "text-visOrange hover:bg-visOrange hover:text-white" : "hover:bg-visOrange hover:text-white"} `}
      >
        <p>{label}</p>
        <ChevronRightIcon className="h-4 w-4" />
        {subMenuOpen && (
          <motion.div className="absolute left-full top-2 min-w-64 text-visBlue">
            <SubMenu subMenu={child} link={id} />
          </motion.div>
        )}
      </div>
    </>
  );
};

const SubMenu = ({ subMenu, link }) => {
  return (
    <div className="flex flex-col divide-y-[1px]">
      {subMenu.map((item, index) => {
        return (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: 130 }}
            animate={{
              opacity: 1,
              x: 0,
              transition: { delay: 0.17 * index, duration: 0.25 },
            }}
          >
            <div
              className={`bg-white p-3 transition-colors duration-200 ${link === item.href ? "text-visOrange hover:bg-visOrange hover:text-white" : "hover:bg-visOrange hover:text-white"}`}
            >
              <NavLink to={`/services/detail/${item.href}`}>
                {item.label}
              </NavLink>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};
